export default __webpack_public_path__ + "static/homepagePartners-4afba9adeff640cb205747c93b5801d5.png";